import { Component } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router"
import { ViewEncapsulation, ViewChild } from '@angular/core';
import { ConsumiblesService } from '@app/_services/consumibles.service';
import { PageChangeEvent, GridDataResult, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService, UsuariosService } from '../_services';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { MyFunctions } from '../_helpers';

@Component({
  selector: 'app-consumibles',
  templateUrl: 'consumibles.component.html'
})

export class ConsumiblesComponent {
  //VARIABLES BASICAS
  private translate: TranslateService;
  public loadingPanel: any = false;

  //GRID: consumibles
  public consumibles: any;
  public seleccionados: number[] = [];

  //POPUP: Eliminar
  public popupEliminar: boolean = false;
  public popupErrorAlEliminar: boolean = false;

  user = this.userService.userValue;

  constructor(private consumiblesService: ConsumiblesService,
    translate: TranslateService,
    private menuService: MenuService, public router: Router,
    private translateService: TranslateService,
    private userService: UsuariosService,
    private modalService: NgbModal) {

    this.translate = translate;
    this.menuService.titulo = this.translate.instant('consumibles').toUpperCase();
  }
  ngOnInit() {
    this.cargarDatos();
  }

  cargarDatos() {
    this.loadingPanel = true;
    this.consumiblesService.Get_consumibles_grid().subscribe(
      (json) => {
        this.consumibles = json;
        this.loadingPanel = false;
      });
  }

  onClickNuevo() {
    this.router.navigate(['consumible/0']);
  }
  onClickEditar() {
    if (this.seleccionados[0] > 0) {
      this.router.navigate(['consumible/', this.seleccionados[0]]);
    }
  }
  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['consumible/', this.seleccionados[0]]);
    }
  }
  onClickEliminar(content) {
    if (this.seleccionados.length > 0) {
      this.popupEliminar = true;
    }
  }

  private eliminarRegistro(contentloading, contentNotErased) {
    this.consumiblesService.Delete_consumible_ids(this.seleccionados).subscribe(
      (json) => {
        this.popupEliminar = false;

        var an: any = json;
        if (an == -1) {
          this.popupErrorAlEliminar = true;
        }
        else {
          this.cargarDatos();
        }

      }
    );
  }

  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
  public showGridTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    if ((element.nodeName === 'TD' || element.nodeName === 'TH' || element.nodeName === 'SPAN')
      && element.offsetWidth < element.scrollWidth) {
      this.tooltipDir.toggle(element);
    } else {
      this.tooltipDir.hide();
    }
  }


  secondsToHms(seconds: number) {
    const days = Math.floor(seconds / 86400);
    const remainderSeconds = seconds % 86400;
    const hms = new Date(remainderSeconds * 1000).toISOString().substring(11, 19);
    return hms.replace(/^(\d+)/, h => `${Number(h) + days * 24}`.padStart(2, '0'));
  }

}
